import { useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Process from './components/Process';
import Portfolio from './components/Portfolio';
import Newsletter from './components/Newsletter';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { useSchemaOrg } from '../../utils/seo';

export default function Home() {
  // Add Organization Schema
  useSchemaOrg({
    type: 'Organization',
    data: {
      name: 'Yepes WebLab',
      description: 'We are not another boring tech company. From concept to launch — we bring ideas to life through smart design, automation, and innovation.',
      logo: 'https://static.readdy.ai/image/f13d1435349aeb632c8499ee5bedeb50/a89402d92b7e9437ddd544d2c10f506d.png',
      email: 'contact@yepesweb.com',
      socialLinks: [],
    },
  });

  // Add WebSite Schema
  useSchemaOrg({
    type: 'WebSite',
    data: {
      name: 'Yepes WebLab',
      description: 'Transform your bold ideas into reality with custom web development and automation solutions. We build innovative websites that make an impact.',
    },
  });

  // Add Service Schema
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    const serviceSchema = {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      itemListElement: [
        {
          '@type': 'Service',
          position: 1,
          name: 'Custom Web Development',
          description: 'Tailored websites built with cutting-edge technology to match your unique vision and business goals.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 2,
          name: 'Automation Solutions',
          description: 'Streamline your workflows with intelligent automation that saves time and reduces manual tasks.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 3,
          name: 'UI/UX Design',
          description: 'Beautiful, intuitive interfaces that engage users and deliver exceptional experiences.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 4,
          name: 'API Integration',
          description: 'Seamlessly connect your systems with third-party services and custom API solutions.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
      ],
    };

    const scriptId = 'schema-services';
    let scriptTag = document.getElementById(scriptId);

    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.id = scriptId;
      scriptTag.type = 'application/ld+json';
      document.head.appendChild(scriptTag);
    }

    scriptTag.textContent = JSON.stringify(serviceSchema);

    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#EBEBE0]">
      <Hero />
      <About />
      <Services />
      <Process />
      <Portfolio />
      <Newsletter />
      <Contact />
      <Footer />
    </div>
  );
}
